import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Protected } from './Protected';
import BaseLayout from './layouts/BaseLayout';
import LoginPage from './pages/auth-pages/Login';

export const Portal: React.FC = () => {
  // User details are now handled in App.tsx
  // Portal just handles routing
  return (
    <Routes>
      <Route path="login" element={<BaseLayout children={<LoginPage />} />} />
      <Route path="*" element={<Protected />} />
    </Routes>
  );
};